const MODEL_EXTENSIONS = ['.stl', '.obj', '.ply'];

export const isImageFile = (file) => file.type.startsWith('image/');

export const is3DFile = (file) => {
    const name = file.name.toLowerCase();
    return MODEL_EXTENSIONS.some(ext => name.endsWith(ext));
};

export const isCBCTFile = (file) => {
    const name = file.name.toLowerCase();
    return name.endsWith('.zip') || name.endsWith('.dcm');
};
